import { translate } from "../app"
import { translations } from "../translations"

interface Props {
  size?: number
  width?: number
  className?: string
}

export function Loader(props: Props) {
  const size = props.size || 32
  const cn = props.className || 'bg-white'
  const label = translate(translations.loading) || "Loading"
  return (
    <div role="status" aria-live="polite" aria-label={label}>
      <div style={{ width: size, height: size, padding: props.width || (size / 4) }} className={`loader ${cn}`} aria-hidden="true"></div>
      <span className="sr-only">{label}</span>
    </div>
  )
}
